<template>
    <router-view/>
    <notification-list/>
</template>

<script>
import NotificationList from '@/components/Notifications/NotificationList'
export default ({
    components: {
        NotificationList
    }
})
</script>

<style>
* {
    padding: 0;
    margin: 0;
    top: 0;
    left: 0;
}

input:focus, textarea:focus, select:focus{
    outline: none;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track-piece {
    background-color: rgba(255, 255, 255, 0.0);
}

::-webkit-scrollbar-thumb {
    background-color: #CBCBCB;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #bbbbbb;
}

::-moz-selection { /* Code for Firefox */
    color: #F4F4F5;
    background: #6366F1;
}

::selection {
    color: #F4F4F5;
    background: #6366F1;
}

</style>
